import React from "react";
import { ExchangeReview } from "../Components";

export const ExchangeReviewPage = () => {
  return <ExchangeReview />;
};
